export default "__VITE_ASSET__cCvhhb3y__"